



























































































































































































import Vue from 'vue';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { evaultCategoryKey } from '@/constants';
import { FileUpload, CloseFullscreenWrapper } from '@/mixins';
import { FileUtils } from '@/helpers';

import { ExtendMixins, s3Instance } from '@/services';

import {
  dateFormat,
  dateTransactionFormat,
  datePickerFormat,
} from '@/constants';

interface Data {
  datePickerFormat: string;
  dateFormat: string;
  dateTransactionFormat: string;
  isLoading: boolean;
  downloadProgress: boolean;
  showErrorMessage: boolean;
  // TODO typings
  attachment: any;
  file: string;
  errorMessage: string;
  showDownloadRefresh: boolean;
}

export default ExtendMixins(
  FileUpload,
  CloseFullscreenWrapper,
).extend({
  name: 'ViewAttachment',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      datePickerFormat,
      dateFormat,
      dateTransactionFormat,
      isLoading: false,
      downloadProgress: false,
      showErrorMessage: false,
      attachment: this.params.attachment,
      file: this.params.file,
      errorMessage: this.params.errorMessage,
      showDownloadRefresh: false,
    };
  },
  computed: {
    isPDF(): boolean {
      return this.attachment.fileName.endsWith('.pdf');
    },
    isTIFF(): boolean {
      const filename = this.attachment.fileName;
      return (
        filename && (filename.endsWith('.tiff') || filename.endsWith('.tif'))
      );
    },
    name(): string {
      return this.attachment.fileNickname
        ? this.attachment.fileNickname
        : this.attachment.fileName;
    },
    category(): string {
      return this.$options.filters.t(
        evaultCategoryKey[this.attachment.category],
      );
    },
  },
  beforeMount() {
    if (this.file) {
      const reader = new window.FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = () => {
        (this.$refs.dynamicImage as any).src = reader.result;
      };
    }
  },
  methods: {
    downloadFile(): void {
      this.downloadProgress = true;
      const EXTENSION = FileUtils.getFilenameExtension(
        this.attachment.fileName,
      );
      s3Instance
        .getFile(`${this.attachment.uuid}.${EXTENSION}`)
        .then((FILE_DATA) => {
          // Edge
          if (window.Navigator.msSaveOrOpenBlob) {
            window.Navigator.msSaveOrOpenBlob(
              FILE_DATA,
              `${this.attachment.fileName}.${EXTENSION}`,
            );
          } else if (window.navigator.msSaveOrOpenBlob) {
            // IE11
            window.navigator.msSaveOrOpenBlob(
              FILE_DATA,
              `${this.attachment.fileName}.${EXTENSION}`,
            );
          } else {
            // Everything else
            this.executeDownload(this.attachment.fileName, FILE_DATA);
          }

          this.downloadProgress = false;
        })
        .catch((error) => {
          // this.showDownloadRefresh = error.response.status !== 404;
          this.showErrorMessage = true;
          this.downloadProgress = false;
        });

      // Trigger analaytics
      window.dataLayer.push({
        event: 'downloadRecords',
      });
    },
    executeDownload(fileName, fileData): void {
      const LINK = document.createElement('a');
      LINK.download = fileName;
      LINK.href = window.URL.createObjectURL(fileData);
      document.body.appendChild(LINK);
      LINK.click();
      LINK.remove();
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
